import { Injectable } from '@angular/core';
import { AngularFirestoreCollection } from '@angular/fire/firestore';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../authentication.service';

import { ConfigurationService } from '../configuration.service';

import { FirestoreService } from './firestore.service';

@Injectable()
export class FirestoreConfigurationService extends ConfigurationService {
    constructor(private authenticationService: AuthenticationService, private firestoreService: FirestoreService) {
        super();
    }

    private get collection(): AngularFirestoreCollection<any> {
        return this.firestoreService.collection<any>('configurations');
    }

    private get tenantCollection(): AngularFirestoreCollection<any> {
        return this.firestoreService.tenantDependentCollection(this.authenticationService.user.tenantId, 'configurations');
    }

    getConfiguration(key: string): Observable<any> {
        return this.collection
            .doc<any>(key)
            .valueChanges()
            .pipe(catchError(() => of(null)));
    }

    getTenantConfiguration(key: string): Observable<any> {
        return this.tenantCollection.doc<any>(key).valueChanges();
    }

    async updateTenantConfiguration(key: string, value: any): Promise<void> {
        return this.tenantCollection.doc<any>(key).set(value, { merge: true });
    }
}
